var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"dashboard-ecommerce"}},[_c('b-row',{staticClass:"match-height"},[_c('b-col',{attrs:{"xl":"12","md":"12"}},[_c('general-stats')],1)],1),_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('orders-list')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }